import { render } from "./BusinessElementRow.vue?vue&type=template&id=2a5c4376&scoped=true"
import script from "./BusinessElementRow.vue?vue&type=script&lang=js"
export * from "./BusinessElementRow.vue?vue&type=script&lang=js"

import "./BusinessElementRow.vue?vue&type=style&index=0&id=2a5c4376&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a5c4376"]])

export default __exports__